import React from "react";
import {Image, ImageSourcePropType, Pressable} from "react-native";
import MainStyle from "../../MainStyle";
import {colors} from "../assets/styles/colors";
import {MaterialCommunityIcons} from '@expo/vector-icons';
import Div from "../lib/Div";
import P from "../lib/P";

type Props = {
  title?: string, value?: string, icon?: ImageSourcePropType, mb?: number, leftText?: string, formik?: any,
  changeFee?: () => void, autoPlayAmount?: number, maxShotAmount?: number, autoPlayEnabled?: boolean
};

const ChallengeInfoCard = (props: Props) => {
  const {title, value, icon, leftText, mb, formik, autoPlayAmount, maxShotAmount, autoPlayEnabled} = props;

  return (
    <Div mb={mb} w={160} h={60} rounded={20} borderWidth={1} borderColor={colors.settings_border}
         bg={colors.settings_bg} row alignItems="center" px={11}>
      {icon && (
        <Div w={36} h={36} rounded={40} borderWidth={1} borderColor={colors.settings_border} justifyContent="center"
             bg={colors.loading_login}>
          <Image source={icon} style={[MainStyle.w_20, MainStyle.h_20, MainStyle.m_x_auto]}/>
        </Div>
      )}

      {leftText && <P fw="500" fs={12} w={52}>{leftText}</P>}

      <Div flex={1} alignItems={title ? 'center' : undefined}>
        {title && <P fw="500" fs={12} ta="center" flex={1}>{title}</P>}
        {value && <P color={colors.newGreenText} tt="capitalize" fw="500" fs={18} ta="center" flex={1}>{value}</P>}

        {formik && (
          <Div alignItems="center">
            <Pressable style={styles.input_wrap} onPress={props.changeFee}>
              <P fw="500" fs={20} color={colors.newGreenText} ta="center" flex={1} minW={36}>
                {(formik.values.contestAmount === '-2' || (autoPlayEnabled && autoPlayAmount === -2)) ? `$${(maxShotAmount || 0) / 100} (Max)` : `$${formik.values.contestAmount}`}
              </P>
              <MaterialCommunityIcons
                name="pencil-outline" size={22} color={colors.newGreenText}
                style={[MainStyle.absolute, MainStyle.r__22]}
              />
            </Pressable>
          </Div>
        )}
      </Div>
    </Div>
  );
};

const styles = {
  input_wrap: [MainStyle.row, MainStyle.relative, MainStyle.b_b_w_1, MainStyle.b_c_newGreen, MainStyle.a_i_c]
};

export default ChallengeInfoCard;
